import React, { useState, useEffect } from 'react'
import messages from './messages'
import { useIntl, FormattedMessage } from 'react-intl'
import { Modal, Button, Icon, Input, Banner } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

export default NiceModal.create(({ file, anonymous = false }) => {
  const [anonymousLink, setAnonymousLink] = useState(null)
  const [publicLink, setPublicLink] = useState(null)
  const [loading, setLoading] = useState(true)
  const [copied, setCopied] = useState(false)
  const { formatMessage } = useIntl()
  const modal = useModal()

  useEffect(() => {
    let promises = []

    promises.push(
      fetch(`/file/generatePublicLink.json?fileId=${file.uid}`)
      .then((response) => response.text())
      .then((link) => {
        console.log({ link })
        setPublicLink(link)
      })
    )

    if (anonymous) {
      promises.push(
        fetch(`/file/generateAnonymousLink.json?fileId=${file.uid}`)
        .then((response) => response.text())
        .then((link) => setAnonymousLink(link))
      )
    }

    Promise.all(promises).then(() => setLoading(false))
  }, [])

  useEffect(() => {
    if (anonymous && anonymousLink?.length) {
      onWriteToClipboard(anonymousLink)
    } else if (!anonymous && publicLink?.length) {
      onWriteToClipboard(publicLink)
    }
  }, [publicLink, anonymousLink])

  const onWriteToClipboard = (url) => {
    navigator.clipboard.writeText(url).then(function() {
      toastr.success(formatMessage(messages.copyLinkSuccess))
    }, function(err) {
      toastr.error(err)
    })

    setCopied(url)
    setTimeout(() => setCopied(null), 4000)
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => modal.remove()}
      className="w-"
    >
      <form className="space-y-8" onSubmit={() => modal.remove()} disabled={loading}>
        { copied &&
            <Banner
              state="success"
              title={formatMessage(messages.copyLinkSuccess)}
            />
        }

        {[
          [publicLink, messages.publicLinkTitle, messages.publicLinkDescription],
          [anonymousLink, messages.anonymousLinkTitle, messages.anonymousLinkDescription]
        ].filter(([link]) => link).map(([link, title, description], index) => (
          <div key={link} className="space-y-2">
            <h4 className="font-medium">
              <FormattedMessage {...title} />
            </h4>

            <p className="text-sm">
              <FormattedMessage {...description} />
            </p>

            <div
              className="p-2 bg-100 border border-gray-200 flex justify-between items-center space-x-2"
              onClick={() => onWriteToClipboard(link)}
            >
              <input
                readOnly
                value={link}
                className="truncate w-full grow font-mono text-gray-700 text-xs"
              />

              <Icon
                icon={['fas', copied == link ? 'check' : 'copy']}
                className="text-primary cursor-pointer"
              />
            </div>
          </div>
        ))}

        <div className="flex justify-end items-center space-x-2">
          <Button type="submit" size="sm" disabled={loading}>
            { loading ? (
              <FormattedMessage {...messages.loading} />
            ) : (
              <FormattedMessage {...messages.submit} />
            ) }
          </Button>
        </div>
      </form>
    </Modal>
  )
})
